function AccordionScripts() {

    /*** ACCORDIANS 
 * preventDefault is used since the page is encapsulated by a form tag and the button triggers a form send... ****/
    $('button.accordion__toggle').click(function (e) {
        e.preventDefault();
    })

}

window.addEventListener("DOMContentLoaded", AccordionScripts);



function components() {
    //Promobanner on homepage
    var random = Math.floor(Math.random() * $('.promo-banner').length);
    $('.promo-banner').eq(random).show();

    //Find and ETP on the education page
    $('.find-an-etf__dropdown .dropdown-item').click(function (e) {
        $('#find-an-etf-dropdown').find('.dropdown__label').html($(this).text());
    });

    var flip = {
        flipBtn: function () {
            var baseUrl = new URL(window.location.href);
            var redirectUrl = baseUrl.searchParams.get("url");
            document.getElementsByClassName("interstitial-view-btn")[0].href = redirectUrl;
        }
    }

    //Flipbutton URL -- where is this used?
    if (document.getElementsByClassName("flip-btn-url").length) {
        flip.flipBtn();
    }

}

window.addEventListener("DOMContentLoaded", components);


//SHOPIFY JAVASCRIPT
window.vaneck = (function (module, $) {
    module.shopify = {
        waitUntilSelectorExists: function (selector, callback, intervalInMiliseconds) {
            intervalInMiliseconds = intervalInMiliseconds || 200;
            var checkExist = setInterval(function () {
                if ($(selector).length) {
                    clearInterval(checkExist);
                    callback();
                }
            }, intervalInMiliseconds);
        },
        getIframeStyleTagWhenLoaded: function (callback) {
            var iframe = '.shopify-buy-frame--productSet > iframe';
            vaneck.shopify.waitUntilSelectorExists(iframe, function () {
                var checkExist = setInterval(function () {
                    var $style = $(iframe).contents().find('style');
                    if ($style.length) {
                        clearInterval(checkExist);
                        callback($style);
                    }
                }, 200);
            });

        },
        applyCssOverrides: function (cssStyleOverrides) {
            $(document).ready(function () {
                var head = $('.shopify-buy-frame--productSet > iframe').contents().find('head');
                var css = 'h1 {color: red !important!}';
                var style = document.createElement('style');

                head.append(style);
                style.type = 'text/css';

                if (style.styleSheet) {
                    // This is required for IE8 and below.
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(document.createTextNode(css));
                }
            })
        }
    };

    return module;
}(window.vaneck || {}, jQuery));


var shopifyEvent;
if (typeof (Event) === 'function') {
    shopifyEvent = new Event('overidejs-loaded');
} else {
    shopifyEvent = document.createEvent('Event');
    shopifyEvent.initEvent('overidejs-loaded', true, true);
}

document.dispatchEvent(shopifyEvent);

//anchored block feature
window.addEventListener('DOMContentLoaded', function () {
    //add the relevant spacing for the blocks with the IDs
    var siteHeaderHeight = $(".mobile-push .site-header").height() + 75 ?? $(".site-header").height() + 50;
    $('.anchored-block').each(function (id) {
/*        let marginTop = parseInt($(this).css("margin-top"));
        let paddingTop = parseInt($(this).css("padding-top"));
        let newPaddingTop = siteHeaderHeight + paddingTop;
        let newMarginTop = marginTop - siteHeaderHeight;
        let newInlineStyles = ';padding-top:' + newPaddingTop + 'px !important; margin-top: ' + newMarginTop + 'px !important';
        let style = $(this).attr('style');
        style += newInlineStyles;
        //console.log(style);
        $(this).attr('style', style);
        //$(window).scrollTop(y + 150);*/
        $(this).css("scroll-margin-top", siteHeaderHeight);
    })
});

window.addEventListener('DOMContentLoaded', function () {
    //used to remove the default margins on the parent element
    $(".remove-parent-margin").each(function () {
        $(this).parent().removeClass("my-5").removeClass("mb-5").removeClass("mt-5");
    })
})


